import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { BmModal, Btn } from '../../ForBrands/ui/BrandUI';

// Pick the single permission (role) a user carries.
const PermissionDialog = ({ open, user, permissions, onClose, onSave }) => {
  const [selected, setSelected] = useState(user?.permissions || []);

  useEffect(() => {
    setSelected(user?.permissions || []);
  }, [user]);

  if (!open || !user) return null;

  const save = () => {
    if (!selected.length) {
      toast.warning('Every user needs at least one permission.');
      return;
    }
    onSave(user, selected);
    onClose();
  };

  return (
    <BmModal
      title={`${user.name || user.email}: permission`}
      onClose={onClose}
      width={720}
      footer={(
        <>
          <Btn variant="secondary" onClick={onClose}>Cancel</Btn>
          <Btn onClick={save}>Save</Btn>
        </>
      )}
    >
      <div className="grid max-h-[50vh] grid-cols-1 gap-2 overflow-y-auto sm:grid-cols-2 md:grid-cols-3">
        {permissions.map((perm) => {
          const active = selected[0] === perm;
          return (
            <button
              key={perm}
              type="button"
              onClick={() => setSelected([perm])}
              className={`flex items-center gap-2 rounded-[8px] border px-3 py-2 text-left bm-body-m transition-colors ${
                active ? 'border-bm-orange bg-bm-subtle text-bm-ink' : 'border-bm-border text-bm-muted hover:border-bm-ink hover:text-bm-ink'
              }`}
              aria-pressed={active}
            >
              <span className={`h-3 w-3 rounded-full border ${active ? 'border-bm-orange bg-bm-orange' : 'border-bm-border bg-white'}`} />
              <span className="break-all">{perm}</span>
            </button>
          );
        })}
      </div>
    </BmModal>
  );
};

export default PermissionDialog;
